module.exports = __webpack_public_path__ + "3b472a011c149d4e3e20899165f9d836.woff2";